// Functional Package imports
import React from 'react';
import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import useStyles from './styles';

export const LoadingScreen = (props) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Skeleton height={80} />
      <Skeleton variant="rect" height={250} />
    </Grid>
  );
};

export const ScoreLoading = () => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Skeleton style={{ marginTop: 10 }} width={'40%'} height={50} />

      {Array.from(new Array(5)).map((d, i) => (
        <LoadingScreen key={i} />
      ))}
    </Grid>
  );
};

export default LoadingScreen;
